/**
 * Einstieg "core": Design-Tokens + gemeinsame Schicht.
 *
 * Uebergang S1 -> S2: stellt die Schicht zusaetzlich als window.PlantClue bereit, damit
 * Alt-Skripte aus js/ sie schon nutzen koennen, bevor sie selbst nach src/components/ umziehen.
 * Wird live erst eingebunden, wenn plantclue-core das Vite-Manifest liest (S3).
 */
import '../tokens/tokens.css';
import * as shared from '../shared/index.js';

window.PlantClue = Object.freeze({ ...shared, locale: shared.config.getPageLocale() });
